import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
    INSERT_UNORDERED_LIST_COMMAND,
    INSERT_ORDERED_LIST_COMMAND,
} from '@lexical/list';

import {
    $getSelection,
    $isRangeSelection,
    FORMAT_TEXT_COMMAND,
} from 'lexical';
import { $createHeadingNode, HeadingTagType } from '@lexical/rich-text';
import { $setBlocksType } from '@lexical/selection';
import { $createParagraphNode } from 'lexical';

import { useEffect, useState } from 'react';

const ToolbarButton = ({
                           label,
                           isActive,
                           onClick,
                       }: {
    label: string;
    isActive?: boolean;
    onClick: () => void;
}) => (
    <button
        type="button"
        onClick={onClick}
        className={`px-2 py-1 rounded text-sm ${
            isActive ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'
        }`}
    >
        {label}
    </button>
);

export function ToolbarPlugin() {
    const [editor] = useLexicalComposerContext();

    const [formats, setFormats] = useState({
        bold: false,
        italic: false,
        underline: false,
    });

    useEffect(() => {
        return editor.registerUpdateListener(({ editorState }) => {
            editorState.read(() => {
                const selection = $getSelection();
                if ($isRangeSelection(selection)) {
                    setFormats({
                        bold: selection.hasFormat('bold'),
                        italic: selection.hasFormat('italic'),
                        underline: selection.hasFormat('underline'),
                    });
                }
            });
        });
    }, [editor]);

    const applyFormat = (format: 'bold' | 'italic' | 'underline') => {
        editor.dispatchCommand(FORMAT_TEXT_COMMAND, format);
    };

    const applyHeading = (heading: HeadingTagType) => {
        editor.update(() => {
            const selection = $getSelection();
            if ($isRangeSelection(selection)) {
                $setBlocksType(selection, () => $createHeadingNode(heading));
            }
        });
    };

    const applyParagraph = () => {
        editor.update(() => {
            const selection = $getSelection();
            if ($isRangeSelection(selection)) {
                $setBlocksType(selection, () => $createParagraphNode());
            }
        });
    };

    return (
        <div className="flex flex-wrap gap-2 mb-3">
            <ToolbarButton
                label="B"
                isActive={formats.bold}
                onClick={() => applyFormat('bold')}
            />
            <ToolbarButton
                label="I"
                isActive={formats.italic}
                onClick={() => applyFormat('italic')}
            />
            <ToolbarButton
                label="U"
                isActive={formats.underline}
                onClick={() => applyFormat('underline')}
            />
            <ToolbarButton label="• List" onClick={() => editor.dispatchCommand(INSERT_UNORDERED_LIST_COMMAND, undefined)} />
            <ToolbarButton label="1. List" onClick={() => editor.dispatchCommand(INSERT_ORDERED_LIST_COMMAND, undefined)} />
            <ToolbarButton label="H1" onClick={() => applyHeading('h1')} />
            <ToolbarButton label="H2" onClick={() => applyHeading('h2')} />
            <ToolbarButton label="P" onClick={applyParagraph} />
        </div>
    );
}
